import { css, Theme } from '@emotion/react'
import { typographyClasses } from '@mui/material'

export const dropzone = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;

  width: 100%;
  padding: ${theme.spacing(4.75, 2)};
  border-radius: 17px;
  border: 1px dashed ${theme.colors.backgroundOne};

  background-color: ${theme.colors.grayHover};
`

export const dropzoneContent = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`

export const label = (theme: Theme) => css`
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 10px;
  cursor: pointer;
`

export const dropzoneError = (theme: Theme) => css`
  border: 1px dashed ${theme.colors.red};
`

export const dropTitle = (theme: Theme) => css`
  color: ${theme.colors.gray};
  font-size: 16px;
  font-weight: 500;
`

export const dropSubtitle = (theme: Theme) => css`
  color: ${theme.colors.gray};
  font-size: 14px;
  font-weight: 400;
`

export const addButton = css`
  width: 48px;
  min-width: 48px;
  height: 48px;
`

export const list = css`
  width: 100%;
  padding: 0;
`

export const listItem = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  padding: 14px;
  border-radius: 20px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
`

export const errorColor = (theme: Theme) => css`
  & .${typographyClasses.root} {
    color: ${theme.colors.red};
  }
`

export const noteCaption = (theme: Theme) => css`
  display: block;

  margin-top: ${theme.spacing(1.25)};

  color: ${theme.typographyColors.typographyThree};
`

export const errorCaption = (theme: Theme) => css`
  display: block;

  margin-top: ${theme.spacing(1.25)};

  color: ${theme.colors.red};
`
